app.controller("aboutUsController", [
    "$scope",
    function ($scope) {
        $scope.controllerName = "aboutUsController";
    }
]);